import React, { useState } from 'react';
import styles from './report-form.module.scss';
import Radio from '@web-common/components/UI/Radio';
import { Button } from 'antd';
import { apiHolder as api, apis, transferLocalDeviceToServerDevice } from 'api';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
const loginApi = api.api.requireLogicalApi(apis.loginApiImpl);
const personalDevice = 'PERSONAL';
const companyDevice = 'COMPANY';
const DeviceReport = props => {
    const { onReportSuccess, deviceMacInfo, isLogin = false } = props;
    const [deviceType, setDeviceType] = useState('');
    const handleDeviceTypeChanged = (ev) => {
        const deviceTypeStr = ev.target.value;
        setDeviceType(deviceTypeStr);
    };
    const [isProcessing, setIsProcessing] = useState(false);
    const handleReportBtnClick = async () => {
        try {
            setIsProcessing(true);
            const newDeviceInfo = Object.assign(Object.assign({}, deviceMacInfo), { deviceType: deviceType });
            const serviceDeviceInfo = transferLocalDeviceToServerDevice(newDeviceInfo);
            (isLogin ? loginApi.reportSecDeviceInfo(serviceDeviceInfo) : loginApi.reportCWDeviceInfo(serviceDeviceInfo)).then(res => {
                if (res.success) {
                    if (onReportSuccess && typeof onReportSuccess === 'function') {
                        onReportSuccess(Object.assign(Object.assign({}, deviceMacInfo), { deviceType: deviceType }));
                    }
                }
                else {
                    SiriusMessage.error(`申报失败：${res.errMsg ? res.errMsg : '上报接口失败'}`);
                }
                setIsProcessing(false);
            });
        }
        catch (ex) {
            setIsProcessing(false);
            SiriusMessage.error(`申报失败：${ex && ex.message ? ex.message : 'Catch'}`);
        }
    };
    if (!deviceMacInfo)
        return null;
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.deviceTypeContainer },
            React.createElement("div", { className: styles.title }, "\u9009\u62E9\u8BBE\u5907\u7C7B\u578B"),
            React.createElement("div", { className: styles.deviceType },
                React.createElement(Radio.Group, { value: deviceType, onChange: handleDeviceTypeChanged },
                    React.createElement(Radio, { value: personalDevice }, "\u4E2A\u4EBA\u8BBE\u5907"),
                    React.createElement(Radio, { value: companyDevice }, "\u4F01\u4E1A\u8BBE\u5907")))),
        React.createElement("div", { className: styles.deviceInfo },
            React.createElement("div", { className: styles.deviceRowInfo },
                React.createElement("div", { className: styles.deviceRowInfoTitle }, "\u8BBE\u5907\u540D\u79F0\uFF1A"),
                React.createElement("div", { className: styles.deviceRowInfoVal }, (deviceMacInfo === null || deviceMacInfo === void 0 ? void 0 : deviceMacInfo.deviceName) || '')),
            React.createElement("div", { className: styles.deviceRowInfo },
                React.createElement("div", { className: styles.deviceRowInfoTitle }, "\u8BBE\u5907\u7CFB\u7EDF\uFF1A"),
                React.createElement("div", { className: styles.deviceRowInfoVal },
                    "\u684C\u9762\u7CFB\u7EDF\uFF08",
                    (deviceMacInfo === null || deviceMacInfo === void 0 ? void 0 : deviceMacInfo.osName) || '',
                    "\uFF09")),
            React.createElement("div", { className: styles.deviceRowInfo },
                React.createElement("div", { className: styles.deviceRowInfoTitle }, "\u8BBE\u5907\u7F16\u7801\uFF1A"),
                React.createElement("div", { className: styles.deviceRowInfoVal }, (deviceMacInfo === null || deviceMacInfo === void 0 ? void 0 : deviceMacInfo.macAddress) || ''))),
        React.createElement("div", { className: styles.actionBtns },
            React.createElement(Button, { type: "primary", loading: isProcessing, disabled: !deviceType, onClick: () => {
                    handleReportBtnClick();
                } }, "\u8BBE\u5907\u7533\u62A5"))));
};
export default DeviceReport;
